@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.workstation-dropdownitem {
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  text-align: left;
  padding: 0 10px;
  border-bottom: 1px solid @printer-dropdown-item--border-color;
  font-size: 13px;
  white-space: nowrap;
  background: @printer-dropdown-item--background-color;
  cursor: default;

  > div {
    color: @printer-dropdown-item--text-color;
  }
}

.workstation-offline {
  font-size: 12px;
  display: inline;
  margin-left: 5px;
  font-weight: @bold;
}

.no-printers {
  color: @printer-dropdown-item--no-items--text-color;
}

.printing-selection {
  width: 100%;
  margin-bottom: 10px;
  button {
    width: 100%;
  }
}
